// sayfalar/TahsilatModal.js
import React, { useState, useEffect, useContext } from 'react';
import { Modal, View, Text, TouchableOpacity, StyleSheet, Vibration } from "react-native";
import CustomAlert from "./CustomAlert";
import HiddenScannerInput from "./HiddenScannerInput";
import { AuthContext } from '../context/AuthContext';

// Ödeme yöntemi renkleri ve etiketleri
const ODEME_CONFIG = {
  NAKIT: { renk: "#4CAF50", label: "NAKİT" },
  KREDI_KARTI: { renk: "#2196F3", label: "KREDİ KARTI" },
  HAVALE: { renk: "#9C27B0", label: "HAVALE" },
  CARI: { renk: "#FF9800", label: "CARİ" }
};

// Varsayılan ödeme yöntemleri (API'den gelmezse)
const VARSAYILAN_ODEME_YONTEMLERI = ["NAKIT", "KREDI_KARTI", "HAVALE", "CARI"];

export default function TahsilatModal({
  visible,
  onClose,
  aktifAdisyon,
  cariler,
  onPaymentConfirm,
  onBarkodScanned,
}) {
  const [odemeYontemi, setOdemeYontemi] = useState();
  const [showConfirm, setShowConfirm] = useState(false);
  const [showError, setShowError] = useState(false);

  const { userToken } = useContext(AuthContext);
  const userInfo = userToken ? JSON.parse(userToken) : null;

  const formatTL = (value) => {
    const number = new Intl.NumberFormat("tr-TR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(value);
    return number + " ₺";
  };

  useEffect(() => {
    if (!visible) {
      setOdemeYontemi(undefined);
      setShowConfirm(false);
      setShowError(false);
    }
  }, [visible]);

  if (!visible) return null;

  const toplamTutar = aktifAdisyon?.items?.reduce((acc, i) => acc + (i.tutar || 0), 0) || 0;
  const aktifCari = cariler?.find(c => c.CariID == aktifAdisyon?.musteri_cari_id);

  if (!aktifCari) {
    return (
      <Modal visible={visible} transparent animationType="fade">
        <View style={styles.overlay}>
          <View style={styles.modalBox}>
            <Text style={styles.title}>Hata</Text>
            <Text style={{ fontSize: 15, color: '#e53e3e', textAlign: 'center', marginVertical: 10 }}>
              Cari bulunamadı.{"\n"}(ID: {aktifAdisyon?.musteri_cari_id ?? "Bilinmiyor"})
            </Text>
            <TouchableOpacity style={styles.closeBtn} onPress={onClose}>
              <Text style={styles.closeText}>Kapat</Text>
            </TouchableOpacity>
          </View>
        </View>
      </Modal>
    );
  }

  // Carinin kullanabileceği ödeme yöntemlerini belirle
const getKullanilabilirOdemeYontemleri = () => {
  // API'den gelen alan: OdemeYotemleri (n eksik)
  if (aktifCari.OdemeYotemleri) {
    const yontemler = aktifCari.OdemeYotemleri.split(',').map(y => y.trim());
    
    return yontemler.filter(yontem => {
      if (yontem === "CARI" && aktifCari.AcikHesap == 0) {
        return false;
      }
      return ODEME_CONFIG[yontem] !== undefined;
    });
  }
  
  
  // Varsayılan
  return VARSAYILAN_ODEME_YONTEMLERI.filter(yontem => {
    if (yontem === "CARI" && aktifCari.AcikHesap == 0) {
      return false;
    }
    return true;
  });
};


  const kullanilabilirYontemler = getKullanilabilirOdemeYontemleri();

  const indirimOrani = aktifCari?.Indirim || 0;
  const indirimliTutar = toplamTutar * (1 - indirimOrani / 100);
  const indirimMiktari = toplamTutar - indirimliTutar;

  const handleOdemeOnay = () => {
    if (!odemeYontemi) {
      setShowError(true);
      return;
    }
    setShowConfirm(true);
  };

  const confirmOdeme = () => {
    setShowConfirm(false);
    Vibration.vibrate(50);

    if (onPaymentConfirm) {
      console.log(odemeYontemi);
      onPaymentConfirm({
        cari_id: aktifAdisyon?.musteri_cari_id,
        cari_adi: aktifAdisyon?.musteri_adi,
        indirim_orani: indirimOrani,
        odeme_yontemi: odemeYontemi,
        tutar: toplamTutar,
        indirim_miktari: indirimMiktari,
        tahsilat: indirimliTutar,
        data: aktifAdisyon,
        note: aktifAdisyon?.note || "",
        kasiyer: userInfo
      });
    }

    onClose();
  };

  const seciliConfig = odemeYontemi ? ODEME_CONFIG[odemeYontemi] : null;
  const seciliRenk = seciliConfig?.renk || "#999";

  return (
    <>
      <Modal visible={visible} transparent animationType="fade">
        <HiddenScannerInput active={visible} onScanned={onBarkodScanned} />
        <View style={styles.overlay}>
          <View style={styles.modalBox}>
            <Text style={styles.title}>Tahsilat</Text>

            <View style={styles.infoRow}>
              <Text style={styles.label}>Cari:</Text>
              <Text style={styles.value}>{aktifCari.Isim}</Text>
            </View>

            {aktifAdisyon?.note ? (
              <View style={styles.infoRow}>
                <Text style={styles.value3}>{aktifAdisyon.note}</Text>
              </View>
            ) : null}

            <View style={styles.infoRow}>
              <Text style={styles.label}>Toplam:</Text>
              <Text style={styles.value}>{formatTL(toplamTutar)}</Text>
            </View>

            <View style={styles.infoRow}>
              <Text style={styles.label}>İndirim:</Text>
              <Text style={styles.value}>({indirimOrani}%) {formatTL(indirimMiktari)}</Text>
            </View>

            <View style={styles.infoRow}>
              <Text style={styles.label2}>Ödenecek Tutar:</Text>
              <Text style={styles.value2}>{formatTL(indirimliTutar)}</Text>
            </View>

            <Text style={[styles.value, { fontWeight: "700", marginBottom: 4 }]}>
              ÖDEME TÜRLERİ
            </Text>

            <View style={styles.odemeRow}>
              {kullanilabilirYontemler.map((yontemKey) => {
                const config = ODEME_CONFIG[yontemKey];
                if (!config) return null;

                return (
                  <TouchableOpacity
                    key={yontemKey}
                    onPress={() => setOdemeYontemi(yontemKey)}
                    style={[
                      styles.odemeBtn,
                      { backgroundColor: config.renk },
                      odemeYontemi === yontemKey && styles.odemeSelected
                    ]}
                  >
                    <Text style={styles.odemeText}>{config.label}</Text>
                  </TouchableOpacity>
                );
              })}
            </View>

            <TouchableOpacity style={styles.confirmBtn} onPress={handleOdemeOnay}>
              <Text style={styles.confirmText}>ÖDEMEYİ ONAYLA</Text>
            </TouchableOpacity>

            <TouchableOpacity style={styles.closeBtn} onPress={onClose}>
              <Text style={styles.closeText}>İptal</Text>
            </TouchableOpacity>
          </View>
        </View>
      </Modal>

      {showConfirm && (
        <CustomAlert
          visible={showConfirm}
          title="Ödeme Onayı"
          message={
            <Text style={{ textAlign: 'center', lineHeight: 45 }}>
              <Text style={{ fontWeight: '400' }}>Cari: </Text>
              <Text style={{ fontWeight: 'bold', fontSize: 18 }}>{aktifCari?.Isim}</Text>
              {"\n"}
              <Text style={{ fontWeight: '400' }}>Tutar: </Text>
              <Text style={{ fontWeight: 'bold', fontSize: 18, color: '#000' }}>
                {formatTL(indirimliTutar)}
              </Text>
              {"\n"}
              <Text style={{ fontWeight: 'bold', fontSize: 30, color: seciliRenk }}>
                {seciliConfig?.label}
              </Text>
            </Text>
          }
          type="warning"
          confirmText="Onayla"
          cancelText="İptal"
          showCancel
          onConfirm={confirmOdeme}
          onCancel={() => setShowConfirm(false)}
        />
      )}

      {showError && (
        <CustomAlert
          visible={showError}
          title="Eksik Bilgi"
          message="Lütfen bir ödeme yöntemi seçiniz!"
          type="error"
          confirmText="Tamam"
          onConfirm={() => setShowError(false)}
        />
      )}
    </>
  );
}

const styles = StyleSheet.create({
  overlay: { flex: 1, backgroundColor: "rgba(0,0,0,0.5)", justifyContent: "center", alignItems: "center" },
  modalBox: { width: "85%", backgroundColor: "white", borderRadius: 20, padding: 20, alignItems: "center", elevation: 10 },
  title: { fontSize: 20, fontWeight: "800", marginBottom: 15 },
  infoRow: { flexDirection: "row", justifyContent: "space-between", width: "100%", marginVertical: 5 },
  label: { fontSize: 16, color: "#444" },
  value: { fontSize: 16, color: "#000" },
  label2: { fontSize: 17, color: "#374151", fontWeight: "700" },
  value2: { fontSize: 18, color: "#16A34A", fontWeight: "800" },
  value3: { fontSize: 18, color: "#ff0000", fontWeight: "800", textAlign: "center" },
  confirmBtn: { backgroundColor: "#4CAF50", padding: 12, borderRadius: 15, marginTop: 10, width: "100%", alignItems: "center" },
  confirmText: { color: "white", fontWeight: "700", fontSize: 16 },
  closeBtn: { backgroundColor: "#ff0000", padding: 12, borderRadius: 15, marginTop: 10, width: "100%", alignItems: "center" },
  closeText: { color: "white", fontWeight: "700" },
  odemeRow: { flexDirection: "row", flexWrap: "wrap", justifyContent: "space-between", width: "100%", marginVertical: 10 },
  odemeBtn: { width: "48%", padding: 5, marginBottom: 10, borderRadius: 12, alignItems: "center" },
  odemeSelected: { borderWidth: 5, borderColor: "#000" },
  odemeText: { color: "white", fontWeight: "700", fontSize: 14 }
});
